import React, { useContext, useMemo } from 'react';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { Trans } from 'react-i18next';
import BasePaymentModal from './BasePaymentModal';

const EndTrialModal = ({ onClose }) => {
  const { account } = useAccount();
  const { t, currency } = useContext(ConfigContext);

  const accountBilling = account?.settings?.billing || {};
  const accountBillingPlan = useMemo(() => accountBilling?.plan || {}, [accountBilling?.plan]);

  const subTitleContent = useMemo(
    () =>
      accountBillingPlan?.slug === 'fixed' ? (
        <Trans
          i18nKey="trialEndedPlanFixed"
          values={{ accountName: account.name, fixedRate: `${accountBillingPlan?.price || 0}${currency}` }}
        />
      ) : (
        <Trans
          i18nKey="trialEndedPlanPerActiveUser"
          values={{ accountName: account.name, perActiveRate: `${currency}${accountBillingPlan?.price || 0}` }}
        />
      ),
    [accountBillingPlan, account.name, currency]
  );

  return (
    <BasePaymentModal
      onClose={onClose}
      title={t('trialEnded')}
      subTitleContent={subTitleContent}
      footerText={t('trialEndedContact')}
    />
  );
};

export default EndTrialModal;
